import { SiteProperties } from '../../../../graphql/horizon-schema'
import { HorizonOption } from '../../types'
import { ChoiceIcon, choiceTransformer, TransformedChoice } from '../choice'

import { sortArray } from './choiceMap'
import { Variant } from './types'

export type SingleOptionChoices = TransformedChoice[]

interface SingleOptionChoicesProps {
  variants: Variant[]
  showOutOfStockAsDisabled: boolean
  displayNotifyWhenInStock: boolean
  horizonOptions: HorizonOption[]
  optionKeysToApplyAttribute?: string[]
  icon?: ChoiceIcon | null
  siteProperties: SiteProperties
}

export const singleOptionChoices = (
  props: SingleOptionChoicesProps,
): SingleOptionChoices => {
  const { optionChoices } = props.variants.reduce<{
    optionChoices: SingleOptionChoices
    storedKeys: Set<string>
  }>(
    (accumulator, variant) => {
      const choice = variant.choices[0]

      if (!accumulator.storedKeys.has(choice.key)) {
        accumulator.optionChoices.push(
          choiceTransformer({
            choice,
            variant,
            showOutOfStockAsDisabled: props.showOutOfStockAsDisabled,
            optionKeysToApplyAttribute: props.optionKeysToApplyAttribute,
            displayNotifyWhenInStock: props.displayNotifyWhenInStock,
            icon: props.icon,
            siteProperties: props.siteProperties,
          }),
        )
        accumulator.storedKeys.add(choice.key)
      }

      return accumulator
    },
    { storedKeys: new Set(), optionChoices: [] },
  )

  const sortedOptionChoices = sortArray({
    horizonOptions: props.horizonOptions,
    choiceOptionKey: props.variants[0].choices[0].optionKey,
    arrayToSort: optionChoices,
  })

  return sortedOptionChoices
}
